import React from "react"
import { Translate } from "utils/i18n-shim"
import { Field, FieldArray } from "formik"
import { FormControlLabel, Grid } from "@mui/material"

import { SubCard } from "shared/ui/berry-jass"
import { DatePicker, PriceInput, Switch } from "shared/ui/berry-jass-formik"
import { getNextDays } from "entities/price-editor"
import { getDateInputAdornmentProps, getPriceInputAdornmentProps } from "shared"
import { SalesProductCard } from "./SalesProductCard"

export const PriceChangeFields = ({ purchaseProduct }) => {
  return (
    <Grid container rowSpacing={3} columnSpacing={2}>
      <Grid item md={12}>
        <SubCard
          title={<Translate value="product.purchase-product.title" />}
          data-testid="purchase-product-fields"
        >
          <Grid container rowSpacing={3} columnSpacing={2}>
            <Grid item md={4} sm={6} xs={12}>
              <Field
                fullWidth
                name="new_purchase_price"
                component={PriceInput}
                label={<Translate value="products.purchase_price.title" />}
                {...getPriceInputAdornmentProps(purchaseProduct.purchase_price)}
              />
            </Grid>
            <Grid item md={4} sm={6} xs={12}>
              <Field
                fullWidth
                name="new_rrp"
                component={PriceInput}
                label={<Translate value="products.rrp.title" />}
                {...getPriceInputAdornmentProps(purchaseProduct.rrp)}
              />
            </Grid>
            <Grid item md={4} xs={12}>
              <Field
                fullWidth
                disablePast
                clearable
                inputFormat="DD.MM.YYYY"
                minDate={getNextDays()}
                name="new_stock_expires_at"
                label={<Translate value="products.stock-date.title" />}
                component={DatePicker}
                {...getDateInputAdornmentProps(
                  purchaseProduct.stock_expires_at
                )}
              />
            </Grid>
          </Grid>
        </SubCard>
      </Grid>
      <FieldArray name="sales_products">
        {() => {
          return (
            <>
              {purchaseProduct.sales_products.map((salesProduct, i) => {
                return (
                  <Grid item md={12} key={salesProduct.id}>
                    <SalesProductCard index={i} data={salesProduct} />
                  </Grid>
                )
              })}
            </>
          )
        }}
      </FieldArray>
      <Grid item xs={12}>
        <SubCard
          title={<Translate value="purchase-products.price-change.settings" />}
          secondary={
            <FormControlLabel
              sx={{ pr: 1 }}
              labelPlacement="start"
              label={
                <Translate value="purchase-products.price-change.activate" />
              }
              control={<Field name="activate" component={Switch} />}
            />
          }
        >
          <Field
            fullWidth
            disablePast
            clearable
            inputFormat="DD.MM.YYYY"
            minDate={getNextDays()}
            name="valid_from"
            label={<Translate value="products.valid-from" />}
            component={DatePicker}
          />
        </SubCard>
      </Grid>
    </Grid>
  )
}
